import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=2986b0bb&scoped=true&"
import script from "./GameInfo.vue?vue&type=script&lang=js&"
export * from "./GameInfo.vue?vue&type=script&lang=js&"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=2986b0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986b0bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VIcon,VRow,VSimpleTable,VTooltip})
